import * as React from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import {
  isCertificateToReplaceOperationAtom,
  isUploadValidExtendedByAtom,
} from "pages/UploadCertificate/state/uploadCertificateStateBase";
import { getCertificateCreateFormAtom } from "raft/CertificateForm";
import Props from "./index.d";

interface GFCFieldSet_InstructionsForValidityWithdrawnWrapperExtended extends Props {
  children: React.ReactNode;
}

const InstructionsForValidityWithdrawnWrapper: React.FC<
  GFCFieldSet_InstructionsForValidityWithdrawnWrapperExtended
> = ({ children }) => {
  const createUnitAtom = getCertificateCreateFormAtom({});
  const [certificateValues] = useRecoilState(createUnitAtom);
  const isUploadValidExtendedBy = useRecoilValue(isUploadValidExtendedByAtom); // show instructions if status is "valid(extended by)", cannot use the statusId to check, because initially (Rev0) the status is "valid"
  const isCertificateToReplaceOperation = useRecoilValue(isCertificateToReplaceOperationAtom);
  // Show children if:
  // 1. This is an extended validity flow (isUploadValidExtendedBy is true), OR
  // 2. The certificate validity status is one of the withdrawn statuses checked in the array below, OR
  // 3. This is a replace operation
  if (
    isUploadValidExtendedBy ||
    ["02ab294a-cfe3-57d0-8831-2d600c44397c", "64e89d04-9533-57f4-8f2d-41f340a29d8b"].includes(
      certificateValues?.certificateValidityStatusId ?? ""
    ) ||
    isCertificateToReplaceOperation
  ) {
    return <>{children}</>;
  }

  // Otherwise, don't render anything
  return null;
};

export default InstructionsForValidityWithdrawnWrapper;
